export default {
  'meta': {
    'langName': 'PORTUGUÊS',
    'lang': 'Português'
  },
  'title': 'RECOLHA DE PRODUTO TABELA DE BASQUETE HOOP B900 BOX NBA TARMAK',
  'description': 'Na sequência dos nossos controlos de qualidade, identificamos que existe o risco de o poste cair no cesto de basquetebol b900 se for usado sem a manivela. Para sua segurança pedimos que pare de usar imediatamente a manivela de ajuste de altura instalada. E informamos que vai ser possível garantir a segurança do seu produto  com um simples procedimento e um kit de reparação que lhe será entregue sem qualquer custo.\nEste site dedicado a esta recolha de produto está em construção. Ele irá guiá-lo pelas diferentes etapas para realizar esta operação.\nInformaremos logo que esteja disponível (em julho).',
  'status': 'Translation validated by COUNTRY'
} as const
